<template>
  <div>
    <form class="form-horizontal" action style="width:520px;margin:0 auto;">
      <h4 class="font_lg font_bold text-center" style="padding:100px 0 20px;">{{$t('restPasswords.Rest.Passwords')}}</h4>
      <div class="text_left light_bg_color" style="margin-bottom: 20px">
        <span class="font_bold">{{$t("common.hint.password.title")}}</span>
        <br/>
        <ul class="tip_list">
          <li v-for="n in 3" :key="n">
            <i class="fa fa-minus font_sm" aria-hidden="true"></i>
            {{$t(`common.hint.password.text${n}`)}}
          </li>
        </ul>
      </div>
      <md-field :class="[{ 'md-error': errors.has('email') }]">
        <label>{{ $t("common.email") }}</label>
        <md-input
          v-model="form.email"
          data-vv-name="email"
          disabled
          type="email"
          required
          v-validate="modelValidations.email"
          autocomplete="username"
        ></md-input>
      </md-field>
      <md-field :class="[{ 'md-error': errors.has('password') }]">
        <md-input
          v-model="form.password"
          data-vv-name="password"
          ref="password"
          required
          type="password"
          v-validate="modelValidations.password"
          autocomplete="new-password"
        ></md-input>
        <label>{{ $t("common.password") }}</label> <!-- Must be after input for autofill fix -->
      </md-field>
      <div class="strength">
        <span v-if="strengthWith(form.password) >= 0 && form.password.length"></span>
        <span v-if="strengthWith(form.password) >= 3"></span>
        <span v-if="strengthWith(form.password) >= 4"></span>
      </div>
      <md-field :class="[{ 'md-error': errors.has('passwordRepeat') }]">
        <md-input
          v-model="form.passwordRepeat"
          data-vv-name="passwordRepeat"
          ref="passwordRepeat"
          required
          type="password"
          v-validate="modelValidations.passwordRepeat"
          autocomplete="new-password"
        ></md-input>
        <label>{{ $t("common.password.repeat") }}</label> <!-- Must be after input for autofill fix -->
      </md-field>
      <div class="flex flex_center">
        <md-button
          class="opacity_5"
          :class="{ 'md-primary': submitBtnStatus }"
          @click="submit"
        >{{ $t("common.button.submit") }}</md-button>
      </div>
    </form>
  </div>
</template>
<script>
import {userApi} from "@/common/api/userApi";
import {navigationPaths} from "@/common/navigation/navigationPaths";

export default {
  data() {
    return {
      modelValidations: {
        email: {
          required: true
        },
        password: {
          required: true
        },
        passwordRepeat: {
          required: true
        }
      },
      form: {
        email: "",
        password: "",
        passwordRepeat: "",
        token:''
      }
    };
  },
  beforeMount(){
      let {query}=this.$route
      if(query&&query.email){
          this.form.email=query.email
          this.form.token=query.token
      }

  },
  methods: {
    submit() {
      if (!this.submitBtnStatus) {
        return;
      }
      userApi.SetPassword(this.form)
          .then((res) => {
          	if (res.nextStatus.startsWith("ACTIVATION_SUCCESS")) {
	            this.$router.replace("/activation?status=" + res.nextStatus);
			} else {
				this.$router.replace(navigationPaths.login.base);
			}
          })
          .catch(err => {
            this.toast(err);
          });
    }
  },
  computed: {
    submitBtnStatus() {
      let status = true;
      for (let field in this.form) {
        if (!this.form[field]) status = false;
      }
      let { passwordRepeat, password } = this.form;
      if (passwordRepeat !== password) {
        status = false;
      }
      return status;
    }
  }
};
</script>

<style lang="scss" scoped>
  .tip_list {
    list-style: none;
    padding: 0;
    margin: 10px 0;
    li:nth-of-type(2) {
      margin: 0;
    }
    i {
      padding-right: 12px;
    }
  }
</style>